import type { MaybeRefOrGetter, Ref } from 'vue';
import { computed, ref, toValue } from 'vue';
import { useResizeObserver } from '@vueuse/core';

export type ContainerQueryResult = {
  width: number;
  isBelowBreakpoint: boolean;
};

export const useContainerQuery = (
  container: Ref<HTMLElement | null>,
  maxWidth: MaybeRefOrGetter<number>
) => {
  const width = ref(0);

  useResizeObserver(container, (entries) => {
    const entry = entries[0];
    if (entry) {
      width.value = entry.contentRect.width;
    }
  });

  const slotProps = computed<ContainerQueryResult>(() => {
    const w = Number(width.value);
    return {
      width: w,
      isBelowBreakpoint: w < toValue(maxWidth)
    };
  });

  return {
    slotProps
  };
};
